import { render, staticRenderFns } from "./Iwitness.vue?vue&type=template&id=766a5671&scoped=true"
import script from "./Iwitness.vue?vue&type=script&lang=js"
export * from "./Iwitness.vue?vue&type=script&lang=js"
import style0 from "./Iwitness.vue?vue&type=style&index=0&id=766a5671&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "766a5671",
  null
  
)

export default component.exports